import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { interval, Subscription, take } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { TagUntagService, DetailsPopupService, ModelLoaderService, LaneBulbService, LoaderService } from '../../services/index';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { LaneTaggingComponent } from './lane-tagging/lane-tagging.component';
// import { TagUntagService ,DetailsPopupService, ModelLoaderService, LaneBulbService,LoaderService} from '../3dPlanogram/services/index';
@Component({
  selector: 'app-planogram',
  templateUrl: './planogram.component.html',
  styleUrls: ['./planogram.component.css'],
})
export class PlanogramComponent
  implements OnInit, OnChanges, OnDestroy {
  @Input() masterLaneList: any;
  @Input() isTimerEnabled: boolean;
  progressbarValue = 100;
  curSec: number;
  masterPlanogramData: any[] = [];
  toolTipMessage: any;
  untagged: Map<string, boolean> = new Map<string, boolean>();
  timeSub: any;
  intervalTimer: any;
  subscription: any;
  previousResponse: any[] = [];
  previousData: any[] = [];
  loading$ = this._loaderService.loading$;
  laneNames: string[] = [];

  private _tileFilterList: any = [
    {
      isSelected: false,
      name: 'Sort Area',
      key: 'waitingCount',
      state: 'sortarea',
      label: 'Monotainer Waiting for Entry',
      noData: 'No Monotainer Waiting for Entry'
    },
    {
      isSelected: true,
      name: 'In Lane',
      key: 'insideCount',
      state: 'inside',
      label: 'Monotainer In Lane',
      noData: 'No Monotainer In Lane'
    },
    {
      isSelected: false,
      name: 'Misplaced',
      key: 'mismatchCount',
      state: 'mismatch',
      label: 'Monotainer Misplaced',
      noData: 'No Misplaced Monotainer'
    },
    {
      isSelected: false,
      name: 'Missing',
      key: 'missingCount',
      state: 'missing',
      label: 'Monotainer Missing',
      noData: 'No Missing Monotainer'
    },
  ];

  private _modelsLoad: Boolean;
  private _timeSub: Subscription;
  private _intervalTimer: any;
  private _subscription: Subscription;
  private _previousResponse: any[] = [];
  private _temp: any[] = [];
  private _available: string[] = [];
  private _sortArea: Map<string, boolean> = new Map<string, boolean>();
  private _filteredSoredArea: Map<string, boolean> = new Map<string, boolean>();
  private _inLane: Map<string, boolean> = new Map<string, boolean>();
  private _inside: Map<string, boolean> = new Map<string, boolean>();
  private _inLaneAni: Map<string, string> = new Map<string, string>();
  private _misplace: Map<string, boolean> = new Map<string, boolean>();
  private _availableMonotianer: Map<string, any> = new Map<string, any>();
  private _laneDetails: Map<string, any> = new Map<string, any>();
  private _monotianerStack: Map<string, string> = new Map<string, string>();
  private _outside: Map<string, boolean> = new Map<string, boolean>()
  private _forceClearSubscription: Subscription;
  private _getPlanogramDataSubscription: Subscription;
  private _afterClosedSubscription: Subscription;
  private _afterClosedResetLaneSubscription: Subscription;

  constructor(
    private _service: ServicecallService,
    private _router: Router,
    private _dataSer: DataService,
    public _dialog: MatDialog,
    private _tagUntagService: TagUntagService,
    private _detailsPopUpService: DetailsPopupService,
    private _modelLoaderService: ModelLoaderService,
    private _laneBulbService: LaneBulbService,
    private _loaderService: LoaderService
  ) {
    this._subscription = this._dataSer.events.subscribe((res: any) => {
      if (
        (res.name === 'siteChanged' ||
          res.name === 'apiRefresh' ||
          res.name === 'trackerSiteChanged')
      ) {
        setTimeout(() => {
          if (this._service.getSiteId()) {
            this._getPlanogramData('default');
          }
        }, 0);
      }
    });
  }

  ngOnInit(): void {
    this._getPlanogramData();
    this.toolTipMessage = this._service.getConfiguration('infoMessage')
      ? this._service.getConfiguration('infoMessage')?.['infoMessage']?.tat
      : {};
    this._tagUntagService.modelLoaded.pipe(
      take(1)
    ).subscribe(
      (state) => {
        this._getPlanogramData('refresh');
      }
    );
  }
  ngOnChanges() {
    // if (this.masterLaneList && this.masterLaneList.length) {
    //   this.masterLaneList.forEach((elem: any, index: number) => {
    //     if (elem?.laneDetails && elem?.laneDetails?.mappedEntities.length) {
    //       const count = elem?.laneDetails?.mappedEntities.filter((item: any) => item.category !== 'ISA') ? elem?.laneDetails?.mappedEntities.filter((item: any) => item.category !== 'ISA').length : null;
    //       this.masterLaneList[index].alertCount = count;
    //     }
    //   });
    // }
    // this.masterLaneList.map((elem: any) => {
    //   const inLaneCount = elem?.laneDetails?.mappedEntities?.length;
    //   if (inLaneCount) {
    //     this.tileFilterList[1].value = inLaneCount;
    //   } else {
    //     this.tileFilterList[1].value = 0;
    //   }
    //   elem['laneFilter'] = this.tileFilterList.map(x => Object.assign({}, x));
    // });
    if (!this.isTimerEnabled) {
      this._clearTimer();
    } else if (this.isTimerEnabled) {
      this._getPlanogramData('refresh');
    }
  }

  ontileFilterChange(masterListIndex: number, filterIndex: number) {
    this.masterPlanogramData[masterListIndex]?.laneFilter.map(
      (elem: any) => (elem.isSelected = false)
    );
    this.masterPlanogramData[masterListIndex].laneFilter[
      filterIndex
    ].isSelected = true;
    this._previousResponse = this.masterPlanogramData;
  }

  getTitle(laneItem: any) {
    const title = laneItem?.laneFilter?.find((item: any) => item?.isSelected);
    return title ? title?.label : '';
  }

  navigateToAsset(entity: any) {
    const routerEndpoint = 'assets' + '/profile/' + entity.entityId;
    this._router.navigate([routerEndpoint]);
  }

  getNoDataLabel(laneItem: any) {
    const noDataItem = laneItem?.laneFilter.find(
      (item: any) => item.isSelected
    );
    return noDataItem ? noDataItem?.noData : '';
  }

  tagMonotainers(zoneId: any, type: any, monotainers?: any) {
    let dialogRef = this._dialog.open(LaneTaggingComponent, {
      width: '30%',
      disableClose: true,
      data: {
        msg: type,
        item: { zoneId: zoneId, site: this._service.getSiteId() },
        monotainers: monotainers,
      },
    });
    this._afterClosedSubscription = dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this._getPlanogramData();
      }
    });
  }
  getFilterItem(elem: any) {
    if (elem) {
      return elem.find((item: any) => item.isSelected)?.state;
    }
    return '';
  }
  navigationToSite() {
    this._router.navigate(['/plants/profile/' + this._service.getSiteId()]);
  }

  navigationToAlert(
    navigateId: any,
    type: any,
    zoneName?: any,
    from?: string,
    to?: string
  ) {
    type === 'entityId'
      ? this._router.navigate(['/events/alerts', navigateId])
      : this._router.navigate(['events/alerts'], {
        queryParams: {
          laneId: navigateId,
          laneName: zoneName,
          fromDate: from,
          toDate: to,
          status: 'active',
        },
      });
  }

  getStateLabel(state: string) {
    switch (state) {
      case 'init':
        return 'Available'; //tag
      case 'inside':
        return 'In lane';
      case 'outside':
        return 'Outside';
      case 'sortarea':
        return 'Sort Area'; //untag
      case 'missing':
        return 'Missing'; //untag
      case 'mismatch':
        return 'Misplaced';
      case 'untagged':
        return 'Untagged';
      case 'delayed':
        return 'Delayed';
      case 'mismatch_inlane':
        return 'Misplaced';
      default:
        return 'NA';
    }
  }
  resetLane(laneName: string, zoneId: any) {
    let dialogRef = this._dialog.open(AlertDialogComponent, {
      data: {
        msg:
          'Are you sure you want to Reset ' + (laneName ? laneName : '') + '?',
        type: null,
        class: 'header-large',
      },
      disableClose: true,
    });
    this._afterClosedResetLaneSubscription = dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this._forceClear(zoneId);
      }
    });
  }
  ngOnDestroy(): void {
    this._forceClearSubscription?.unsubscribe();
    this._getPlanogramDataSubscription?.unsubscribe();
    this._afterClosedSubscription?.unsubscribe();
    this._afterClosedResetLaneSubscription?.unsubscribe();
    this._timeSub?.unsubscribe();
    this._clearTimer();
    if (this._subscription) this._subscription?.unsubscribe();

  }
  private _forceClear(zoneId: any) {
    const payload = {
      zoneIds: [zoneId]
    };
    this._forceClearSubscription = this._service.forceClear(payload).subscribe((res: any) => {
      if (res) {
        this._service.toasterService({ type: 'success', msg: res['message'] });
      } else {
        this._service.toasterService({ type: 'error', msg: res['message'] });
      }
      this._getPlanogramData();
    });
  }

  private _getPlanogramData(type: any = 'default') {
    this._modelsLoad = this._modelLoaderService.getModelLoadFlag();
    if (this._modelsLoad == true) {
      this._clearSortArea();
      this._startTagAnimation();
      this._gotoLane();
    } else {
      this._sortArea.clear();
      this._filteredSoredArea.clear();
      this._inLane.clear();
      this._inside.clear();
      this._inLaneAni.clear();
      this._misplace.clear();
      this.untagged.clear();
      this._availableMonotianer.clear();
      this._laneDetails.clear();
      this._monotianerStack.clear();
      this._tagUntagService.setLaneStackPosition()
    }
    this._getPlanogramDataSubscription = this._service.getPlanogramData(type).subscribe((res: any) => {
      if (res?.length) {
        this.masterPlanogramData = res;
        this._modelLoaderService.setCssBillboard(res);
        this.masterPlanogramData.map((elem: any) => {
          if (this._previousResponse?.length) {
            const prevData = this._previousResponse.find(
              (item: any) => item.zoneId === elem.zoneId
            );
            prevData
              ? (elem['laneFilter'] = prevData['laneFilter'])
              : (elem['laneFilter'] = this._tileFilterList.map((x) =>
                Object.assign({}, x)
              ));
          } else {
            elem['laneFilter'] = this._tileFilterList.map((x) =>
              Object.assign({}, x)
            );
          }
          elem['alerts'] = elem?.alerts.sort((a, b) =>
            a?.sourceTimestamp > b?.sourceTimestamp ? 1 : -1
          );
          elem['batchTat'] = this._secondConverter(elem?.batchTat);
          this._laneDetails.set(elem.zoneName, elem);
          if (this._modelsLoad) {
            if (elem.missingCount > 0) {
              this._laneBulbService.setLaneBulbRed(elem.zoneName);
            } else {
              this._laneBulbService.setLaneBulbGrey(elem.zoneName);
            }
          }
          elem?.monotainers.forEach((item: any) => {
            item['monotainerAlerts'] = elem?.alerts?.filter(
              (alertElem: any) => alertElem?.entityId === item?.entityId
            )?.length;

            this._availableMonotianer.set(item.name, item);
            /*
            gets monotianers in sort area,and starts tag animation for selected monotianers
            */
            if (this._modelsLoad) {
              if (
                (item.state === 'sortarea' ||
                  item.state === 'missing') &&
                !(this._sortArea.has(item.name) || this._filteredSoredArea.has(item.name))
              ) {
                if (((new Date().getTime() - new Date(item.taggedTime).getTime()) > 60000)) {
                  this._filteredSoredArea.set(item.name, false)
                } else {
                  this._sortArea.set(item.name, false);
                }
              }
              /*gets monotianers inlane(including mismatch),and starts InLane animation for selected monotianers*/
              if (
                (item.state === 'inside' ||
                  item.state === 'mismatch_inlane' ||
                  item.state === 'untagged' ||
                  item.state === "delayed") &&
                !this._inLane.has(item.name)
              ) {
                this._inLane.set(item.name, false);
                this._inLaneAni.set(item.name, elem.zoneName);
                if (elem.stack == 2 && item.stackPosition === 2) {
                  this._monotianerStack.set(item.name, 'top');
                } else {
                  this._monotianerStack.set(item.name, 'bottom');
                }
                if (item.state === 'inside' || item.state === 'delayed') {
                  this._inside.set(item.name, false);
                  this._outside.forEach((value, key) => {
                    if (this._inside.has(key)) {
                      this._outside.delete(key)
                    }
                  })
                }
                if (item.state === 'untagged') {
                  this.untagged.set(item.name, false);
                }
                if (item.state === 'inside' && this._misplace.has(item.name)) {
                  this._misplace.delete(item.name);
                }
                if (
                  item.state === 'mismatch_inlane' &&
                  !this._misplace.has(item.name)
                ) {
                  this._misplace.set(item.name, false);
                }
                this._gotoLane();
              }
              if (item.state == 'outside' && !this._outside.has(item.name)) {
                this._outside.set(item.name, false);
                this._outside.forEach((value, key) => {
                  if (this._inLane.has(key)) {
                    this._inLane.delete(key)
                    this._tagUntagService.removefromLane(this._outside)
                  }
                })
              }
              this._temp.push(item.name);
            }
          });
        });

        this._available = Array.from(this._availableMonotianer.keys());
        if (this._modelsLoad) {
          this._detailsPopUpService.setDetailsMonotianer(
            this._availableMonotianer
          );

          this._detailsPopUpService.setLaneDetails(this._laneDetails);
          /*
        for untag of monotainer gets the details of inlane monotainer and checks it with
        available monotianers to find which monotainer got untagged*/
          //inLaneAni needs to be deleted after untag animation exited
          this._available.forEach((element) => {
            if (this._temp.indexOf(element) == -1) {
              this._available = this._available.filter((data) => data != element);
              this._availableMonotianer.delete(element);
              this._filteredSoredArea.delete(element);
              this._sortArea.delete(element);
              this._inLane.delete(element);
              this._misplace.delete(element);
              this.untagged.delete(element);
              if (this._modelsLoad) {
                this._tagUntagService.unTagMonotainer(element);
              }
            }
          });
          this._temp = [];
        }

        if (this._modelsLoad) {
          this._loaderService.hide();
        }
      }
      this._clearTimer();
      this._intervalTimer = setInterval(() => {
        this._getPlanogramData('refresh');
      }, 10000);
      this._refreshTimer();
    });
  }
  /**
   * Starts tag animation
   */
  private _startTagAnimation() {
    this._sortArea.forEach((value, key) => {
      if (value == false) {
        this._tagUntagService.tagMonotainer(key, this._sortArea);
        this._sortArea.set(key, true);
      }
    });
  }

  /**
   * Clears sort area
   */
  private _clearSortArea() {
    this._filteredSoredArea.forEach((value, key) => {
      if (value == false) {
        this._tagUntagService.clearFromSortArea(key);
        this._filteredSoredArea.set(key, true);
      }
    });
  }

  /**
   * starts InLane animation
   */
  private _gotoLane() {
    this._inLane.forEach((value, key) => {
      if (value == false && this._modelsLoad) {
        this._tagUntagService.gotoLane(
          this._inLane,
          this._inLaneAni,
          this._monotianerStack,
          this._inside,
          this.untagged,
          this._misplace,
        );
        this._inLane.set(key, true);
      }
    })
  }

  private _refreshTimer() {
    this.progressbarValue = 100;
    this.curSec = 10;
    const timer$ = interval(1000);
    this._timeSub = timer$.subscribe((sec) => {
      // if (!(sec % 10)) {
      this.progressbarValue -= 10;
      // }
      this.curSec = 10 - sec;
      if (sec === 10) {
        this._timeSub.unsubscribe();
      }
    });
  }

  private _clearTimer() {
    if (this._intervalTimer) {
      clearInterval(this._intervalTimer);
      this._timeSub.unsubscribe();
    }
  }
  private _getStatus(filterItem: any) {
    const selectedItem = filterItem?.find((item: any) => item.isSelected);
    if (selectedItem?.state === 'inside') {
      return true;
    } else {
      return false;
    }
  }
  private _secondConverter(totalSeconds: number) {
    // return minutes + ':' + (time - minutes * 60);
    if (totalSeconds) {
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      let result = `${minutes.toString().padStart(1, '0')}:${seconds
        .toString()
        .padStart(2, '0')}`;
      // if (!!hours) {
      result = `${hours.toString()}:${minutes
        .toString()
        .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      // }
      return result;
    } else {
      return '00:00:00';
    }
  }


}
